import { getPosition, selectMonsters } from "./createMonsters";
import { getMagicItems, getMagicWeaponsAndArmor, getMonsters, getPotions, getRandomThreat, getSpells } from "./Logic";

const events = require("../data/events.json");

export function getMerchant({ itemsAmount = 5 }) {
  const merchant = events.find((event) => event.key === "merchant");
  const itemsForSale = [];

  let allItems = [
    ...getPotions().map((p) => {
      if (p.item !== "Roll on the Greater Potion Table") {
        return { ...p, type: "Potion" };
      }
    }),
    ...getMagicWeaponsAndArmor().map((p) => {
      return { ...p, type: "Weapon/armor" };
    }),
    ...getMagicItems().map((p) => {
      return { ...p, type: "Magic Item" };
    }),
  ];
  allItems = allItems.filter((item) => item !== undefined);

  while (itemsForSale.length < itemsAmount && allItems.length > 0) {
    const randomIndex = Math.floor(Math.random() * allItems.length);
    const item = allItems.splice(randomIndex, 1)[0];
    const randomDiscount = Math.floor(Math.random() * (70 - 30 + 1)) + 30;
    item.finalPrice = Math.floor(parseInt(item.purchasePrice)) - Math.floor(parseInt(item.purchasePrice) * (randomDiscount / 100));
    item.discount = randomDiscount + "%";
    itemsForSale.push(item);
  }

  return { merchant, itemsForSale };
}

export function getWizard({ itemsAmount = 3 }) {
  const merchant = events.find((event) => event.key === "wizard");
  const itemsForSale = [];

  let allItems = getSpells();

  while (itemsForSale.length < itemsAmount && allItems.length > 0) {
    const randomIndex = Math.floor(Math.random() * allItems.length);
    const item = allItems.splice(randomIndex, 1)[0];
    item.purchasePrice = 500;
    const randomDiscount = Math.floor(Math.random() * (60 - 30 + 1)) + 30;
    item.finalPrice = Math.floor(parseInt(item.purchasePrice)) - Math.floor(parseInt(item.purchasePrice) * (randomDiscount / 100));
    item.discount = randomDiscount + "%";
    itemsForSale.push(item);
  }
  console.log({ merchant, itemsForSale });
  return { merchant, itemsForSale };
}

// Returns the full list of events (raw data), for listing / manual selection.
export function getAllEvents() {
  return events;
}

// Builds a fresh, self-contained copy of an event with its rolled extraInfo.
// Never mutates the shared module-level `events` objects, so it is safe to call
// repeatedly (e.g. fast re-rolls) without corrupting shared state.
export function rollEvent(event) {
  const rolled = JSON.parse(JSON.stringify(event));

  if (rolled.key === "merchant") {
    rolled.extraInfo = getMerchant({}).itemsForSale;
  }
  if (rolled.key === "wizard") {
    rolled.extraInfo = getWizard({}).itemsForSale;
  }
  if (rolled.key === "warband") {
    const randomOptionIndex = Math.floor(Math.random() * rolled.options.length);
    rolled.group = rolled.options[randomOptionIndex];
    const { minThreat: minParam, maxThreat: maxParam } = rolled;
    rolled.extraInfo = getRandomWarband({ group: rolled.group, minParam, maxParam });
    const position = getPosition();
    rolled.extraInfo.monsters = (rolled.extraInfo.monsters || []).map((monster) => {
      return { ...monster, position };
    });
  }

  return rolled;
}

export function getRandomEvents({ amount = 2 }) {
  const selectedEvents = [];
  const usedIndices = new Set();
  let finalEnvet = events.filter((event) => event.enabled === true);
  while (selectedEvents.length < amount && selectedEvents.length < finalEnvet.length) {
    const randomIndex = Math.floor(Math.random() * finalEnvet.length);
    if (!usedIndices.has(randomIndex)) {
      const event = finalEnvet[randomIndex];
      if (event.isWeather && selectedEvents.some((e) => e.isWeather)) {
        continue;
      }

      usedIndices.add(randomIndex);

      // INSERT_YOUR_CODE
      // 30% chance to add "teamplay" event to selectedEvents

      selectedEvents.push(rollEvent(event));
    }
  }
  if (
    Math.random() < 0.3 // 30% chance
  ) {
    selectedEvents.push({
      encounterName: "Team play",
      quickDescription: "2x2, play as teams.",
      behavior: "2x2, play as teams. Treasures, gold and xp are summed as one and divided by 2. On odds treasure, roll for it.",
      key: "teamplay",
      enabled: true,
    });
  }
  return selectedEvents;
}

export function getRandomWarband({ group, minParam, maxParam }) {
  if (!group === "") {
    alert("Please select a group");
    return [];
  }

  const threatLevel = getRandomThreat({ minParam, maxParam });
  const monsters = getMonsters().filter((monster) => monster.group === group);
  return selectMonsters({ creatures: monsters, targetThreatLevel: threatLevel });
}
